import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../styles.scss';

const FreeFormTextLabel = ({
  isDisabled = true,
  setSelectedAnswer = () => {},
  value: radioButtonValue,
}) => {
  const [answer, setAnswer] = useState({
    id: radioButtonValue,
    stop: true,
    value: '',
    static: false,
  });
  const textAreaRef = useRef(null);
  const el = textAreaRef.current;

  const captureInput = (e) => setAnswer({ ...answer, value: e.target.value });
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (!isDisabled && !isFirstRun.current) setSelectedAnswer(answer);
  }, [isDisabled]);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    setSelectedAnswer(answer);
  }, [answer]);

  useEffect(() => {
    if (el) {
      el.focus();
      el.style.setProperty('height', `${el.scrollHeight}px`);
    }
  });

  const handleClick = () => {
    // Necessary because Chrome browser freaks out on the click event -GH Jan 18, 2020
    setTimeout(() => {
      if (el) el.focus();
    }, 0);
  };

  const showPlaceholder = !answer.value.length && isDisabled;

  return showPlaceholder ? (
    <div className={styles.freeFormContainer}>Other</div>
  ) : (
    <textarea
      ref={textAreaRef}
      value={answer.value}
      maxLength={100}
      readOnly={isDisabled}
      onChange={captureInput}
      onClick={handleClick}
      rows={1}
      className={styles.customerInput}
    />
  );
};

FreeFormTextLabel.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  setSelectedAnswer: PropTypes.func,
  value: PropTypes.any,
};

export default FreeFormTextLabel;

/*
  FreeFormTextLabel: Meant to be used with RadioV2QA. Allows customer to input freeform text.

  Notes:
    - The handleInputSubmission() function uses a ref because the reference to THIS must remain the same between re-renders in
      order for the clearTimeout() function to work as intended. As of this writing the ref object, and therefore ref.current,
      remain the same throughout any re-renders. -GH Jan 22, 2020
*/
